import { render, staticRenderFns } from "./DefectReportPropertiesView.vue?vue&type=template&id=652b565d&scoped=true&"
import script from "./DefectReportPropertiesView.vue?vue&type=script&lang=js&"
export * from "./DefectReportPropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652b565d",
  null
  
)

export default component.exports